import AppPage from './App'

export { AppPage }
